module.exports = __webpack_public_path__ + "img/thumbnail-cover.f1464d42.jpg";